// extracted by mini-css-extract-plugin
export default {"pageRoot":"GroundworksContractorsPage_pageRoot__RA9EL","pageContent":"GroundworksContractorsPage_pageContent__Hl2eX"};